/* LP Ask v1.1 — token-level streaming reveal per SITE-MOTION-SPEC home-chat-response-token-in */
function lpAskInit() {
  var overlay = document.getElementById('lp-ask');
  if (!overlay) return;

  var dataEl = document.getElementById('lp-ask-data');
  var CONFIG = {};
  try { CONFIG = JSON.parse(dataEl.textContent); } catch (e) { CONFIG = {}; }

  if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

  var thread = overlay.querySelector('[data-lp-ask-thread]');
  var sugWrap = overlay.querySelector('[data-lp-ask-suggestions]');
  var input = overlay.querySelector('[data-lp-ask-input]');
  var sendBtn = overlay.querySelector('[data-lp-ask-send]');
  var resetBtn = overlay.querySelector('[data-lp-ask-reset]');

  var history = [];
  var busy = false;
  var closing = false;
  var HISTORY_TURNS = 6;

  function track(name, payload) {
    var detail = payload || {};
    try { document.dispatchEvent(new CustomEvent('lp-ask:' + name, { detail: detail })); } catch (e) {}
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push(Object.assign({ event: 'lp_ask_' + name }, detail));
    }
  }

  function splitKeywords(str) {
    return (str || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function projectById(id) {
    for (var i = 0; i < (CONFIG.projects || []).length; i++) {
      if (CONFIG.projects[i].id === id) return CONFIG.projects[i];
    }
    return null;
  }
  function scrollDown() {
    overlay.scrollTo({ top: overlay.scrollHeight, behavior: 'smooth' });
  }

  function addUser(text) {
    var el = document.createElement('div');
    el.className = 'lp-ask__msg lp-ask__msg--user';
    var b = document.createElement('div');
    b.className = 'lp-ask__bubble';
    b.textContent = text;
    el.appendChild(b);
    thread.appendChild(el);
    scrollDown();
  }

  function addAI() {
    var el = document.createElement('div');
    el.className = 'lp-ask__msg lp-ask__msg--ai';
    var think = document.createElement('div');
    think.className = 'lp-ask__thinking';
    think.innerHTML = '<span></span><span></span><span></span>';
    el.appendChild(think);
    thread.appendChild(el);
    scrollDown();
    return {
      el: el,
      think: think,
      answer: null,
      text: '',
      begin: function () {
        if (this.answer) return;
        if (this.think && this.think.parentNode) this.think.parentNode.removeChild(this.think);
        this.answer = document.createElement('p');
        this.answer.className = 'lp-ask__answer';
        this.el.appendChild(this.answer);
      },
      /* each chunk becomes its own span so it fades + lifts independently */
      write: function (chunk) {
        if (!chunk) return;
        this.begin();
        var tok = document.createElement('span');
        tok.className = 'lp-ask__tok';
        tok.textContent = chunk;
        this.answer.appendChild(tok);
        this.text += chunk;
        scrollDown();
      }
    };
  }

  function renderCards(node, ids) {
    if (!ids || !ids.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'lp-ask__cards';
    var n = 0;
    ids.forEach(function (id) {
      var p = projectById(id);
      if (!p) return;
      var a = document.createElement('a');
      a.className = 'lp-ask__pcard';
      a.href = p.url || '#';
      a.style.setProperty('--i', n);
      a.setAttribute('data-project-id', p.id);

      var imgWrap = document.createElement('span');
      imgWrap.className = 'lp-ask__pcard-img';
      if (p.image) {
        var im = document.createElement('img');
        im.src = p.image;
        im.alt = '';
        im.loading = 'lazy';
        imgWrap.appendChild(im);
      }

      var body = document.createElement('span');
      body.className = 'lp-ask__pcard-body';
      var t = document.createElement('span');
      t.className = 'lp-ask__pcard-title';
      t.textContent = p.title || '';
      var sm = document.createElement('span');
      sm.className = 'lp-ask__pcard-summary';
      sm.textContent = p.summary || '';
      var cta = document.createElement('span');
      cta.className = 'lp-ask__pcard-cta';
      cta.textContent = 'View Project';
      body.appendChild(t); body.appendChild(sm); body.appendChild(cta);

      a.appendChild(imgWrap); a.appendChild(body);
      a.addEventListener('click', function () { track('project_clicked', { project: p.id }); });
      wrap.appendChild(a);
      track('project_surfaced', { project: p.id });
      n++;
    });
    if (n) { node.appendChild(wrap); scrollDown(); }
  }

  function renderCTA(node) {
    var row = document.createElement('div');
    row.className = 'lp-ask__cta-row';
    var a = document.createElement('a');
    a.className = 'lp-ask__cta';
    a.href = CONFIG.ctaUrl || '/pages/contact';
    a.textContent = CONFIG.ctaLabel || 'Discuss your project';
    a.addEventListener('click', function () { track('cta_clicked', {}); });
    row.appendChild(a);
    node.appendChild(row);
  }

  function renderSuggestions(list) {
    sugWrap.innerHTML = '';
    (list || []).slice(0, 3).forEach(function (q, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lp-ask__suggestion';
      b.style.setProperty('--i', i);
      b.textContent = q;
      b.addEventListener('click', function () {
        track('suggestion_clicked', { question: q });
        submit(q);
      });
      sugWrap.appendChild(b);
    });
  }

  function localAnswer(question) {
    var q = question.toLowerCase();
    var best = null, bestScore = 0;
    (CONFIG.knowledge || []).forEach(function (entry) {
      var score = 0;
      splitKeywords(entry.keywords).forEach(function (k) { if (k && q.indexOf(k) !== -1) score += 2; });
      if (entry.title && q.indexOf(entry.title.toLowerCase()) !== -1) score += 3;
      if (score > bestScore) { bestScore = score; best = entry; }
    });
    (CONFIG.projects || []).forEach(function (p) {
      if (p.title && q.indexOf(p.title.toLowerCase()) !== -1 && bestScore < 3) {
        bestScore = 3;
        best = { content: p.summary, projects: p.id, cta: false };
      }
    });
    if (!best || bestScore === 0) {
      return {
        status: 'unmatched',
        message: CONFIG.unmatched,
        content: [],
        suggestedQuestions: CONFIG.starters || [],
        cta: false
      };
    }
    return {
      status: 'matched',
      message: best.content,
      content: splitKeywords(best.projects),
      suggestedQuestions: (CONFIG.starters || []).filter(function (s) { return s.toLowerCase() !== q; }).slice(0, 3),
      cta: !!best.cta
    };
  }

  /* local mode: emit word-level tokens so the reveal matches real streaming */
  function typeOut(node, text, done) {
    var tokens = (text || '').match(/\S+\s*/g) || [];
    var i = 0;
    (function tick() {
      if (i >= tokens.length) { done && done(); return; }
      node.write(tokens[i]);
      i++;
      setTimeout(tick, 34);
    })();
  }

  function streamFromServer(question, node, finish) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 30000);

    fetch(CONFIG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: question, history: history.slice(-HISTORY_TURNS) }),
      signal: controller.signal
    }).then(function (res) {
      if (!res.ok || !res.body) throw new Error('bad response');
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var meta = null;

      function pump() {
        return reader.read().then(function (r) {
          if (r.done) { clearTimeout(timeout); finish(meta); return; }
          buffer += decoder.decode(r.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop();
          lines.forEach(function (line) {
            if (line.indexOf('data:') !== 0) return;
            var raw = line.slice(5).trim();
            if (!raw || raw === '[DONE]') return;
            var evt;
            try { evt = JSON.parse(raw); } catch (e) { return; }
            if (evt.type === 'text' && evt.delta) node.write(evt.delta);
            if (evt.type === 'meta') meta = evt;
          });
          return pump();
        });
      }
      return pump();
    }).catch(function () {
      clearTimeout(timeout);
      node.begin();
      if (!node.text) {
        node.write('Something went wrong reaching our assistant. Please try again, or get in touch directly.');
      }
      finish(null);
    });
  }

  function submit(text) {
    var q = (text || '').trim();
    if (!q || busy) return;
    if (q.length > (CONFIG.maxLength || 500)) q = q.slice(0, CONFIG.maxLength || 500);

    busy = true;
    sendBtn.disabled = true;
    input.value = '';
    input.style.height = 'auto';
    sugWrap.innerHTML = '';

    addUser(q);
    track('question_submitted', { chars: q.length });

    var node = addAI();

    function finish(result) {
      var r = result || {};
      node.begin();
      renderCards(node.el, r.content ? r.content.map(function (c) { return typeof c === 'string' ? c : c.id; }) : []);
      if (r.cta) renderCTA(node.el);
      renderSuggestions(r.suggestedQuestions && r.suggestedQuestions.length ? r.suggestedQuestions : CONFIG.starters);
      if (r.status === 'unmatched') track('unmatched', { question: q });
      history.push({ role: 'user', content: q });
      history.push({ role: 'assistant', content: node.text });
      if (history.length > HISTORY_TURNS) history = history.slice(-HISTORY_TURNS);
      busy = false;
      sendBtn.disabled = false;
      scrollDown();
    }

    if (CONFIG.endpoint) {
      streamFromServer(q, node, finish);
    } else {
      var result = localAnswer(q);
      setTimeout(function () {
        typeOut(node, result.message || '', function () { finish(result); });
      }, 420);
    }
  }

  function open() {
    closing = false;
    overlay.classList.remove('is-closing');
    overlay.hidden = false;
    document.body.classList.add('lp-ask-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('is-open'); }); });
    if (!thread.children.length) renderSuggestions(CONFIG.starters);
    setTimeout(function () { input.focus(); }, 320);
    track('opened', {});
  }
  function close() {
    if (closing || overlay.hidden) return;
    closing = true;
    overlay.classList.add('is-closing');
    overlay.classList.remove('is-open');
    document.body.classList.remove('lp-ask-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      overlay.hidden = true;
      overlay.classList.remove('is-closing');
      closing = false;
    }, 180);
  }
  function reset() {
    thread.innerHTML = '';
    history = [];
    renderSuggestions(CONFIG.starters);
    input.value = '';
    input.focus();
    track('reset', {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lp-ask-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-lp-ask-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-lp-ask-explore]')) {
      e.preventDefault();
      close();
      setTimeout(function () {
        var exploreOpener = document.querySelector('[data-lp-explore-open]');
        if (exploreOpener) exploreOpener.click();
      }, 200);
      return;
    }
    if (!overlay.hidden && e.target.closest('.lp-ask') && !e.target.closest('.lp-ask__card')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });

  sendBtn.addEventListener('click', function () { submit(input.value); });
  resetBtn.addEventListener('click', reset);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(input.value); }
  });
  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lpAskInit);
} else {
  lpAskInit();
}
